import { FormikProps } from 'formik';
import { ReactElement } from 'react';

export interface SystemState {
    loggedIn: boolean;
    session: string;
    username: string;
    showLoading: boolean;
    messageResponse: MessageResponse | null;
    showHeader: boolean;
    showMenubar: boolean;
    showFooter: boolean;
    title:string;
  }

export interface MessageResponse{
    code: number,
    message : string [],
    process?: string
}

export interface List {
    id: string;
    value: string;
}

export interface ListReactElement {
    icon: ReactElement;
    text: string;
}

export interface FormFlowProps<T> {
    currentStep: number,
    previousPage: any,
    nextPage: any,
    errorMessage : string | React.ReactElement | null,
    validateResponse: any ,
    formikProps: FormikProps<T>
}

export interface ListElement {
    content: ReactElement[];
    id: string;
}

export interface ListTestimonials {
    iconquotation: ReactElement;
    iconstart: ReactElement[];
    content: string;
    text: string;
}

export interface ListMenu {
    id: string;
    value: string;
    active: boolean;
}

export const UPDATE_SESSION = "UPDATE_SESSION";
export const TOGGLE_LOADING_INDICATOR = "TOGGLE_LOADING_INDICATOR";
export const SHOW_MESSAGE_RESPONSE_QUESTION = "SHOW_MESSAGE_RESPONSE_QUESTION";
export const SET_MESSAGE_RESPONSE = 'SET_MESSAGE_RESPONSE';
export const SHOW_HEADER = "SHOW_HEADER";
export const SHOW_MENUBAR = "SHOW_MENUBAR";
export const SET_TITLE="SET_TITLE";
export const RESET_TITLE="RESET_TITLE";
export const SHOW_FOOTER="SHOW_FOOTER";

type AcceptedTypes = typeof UPDATE_SESSION | typeof TOGGLE_LOADING_INDICATOR | typeof SET_MESSAGE_RESPONSE
     | typeof SHOW_HEADER| typeof SHOW_MENUBAR | typeof SET_TITLE | typeof RESET_TITLE | typeof SHOW_FOOTER;

interface UpdateSessionAction {
    type: AcceptedTypes;
    payload: SystemState | boolean| string | MessageResponse ;
}

export type SystemActionTypes = UpdateSessionAction ;
